<apm-section-title title="{{ 451853 | apmTranslate }}"></apm-section-title>

<form [formGroup]="form" class="working-conditions-form">
  <!-- UNIT SYSTEM -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 451846 | apmTranslate }}</div>
    <hr class="gray-divider-1" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 444899 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="unitSystemOptions"
          [useResourceTemplate]="true"
          [clearable]="false"
          (selectChange)="onSystemUnitChange($event)"
          bindLabel="label"
          bindValue="value"
          formControlName="uomSystem"
        ></apm-select>
      </div>
    </div>
  </div>

  <!-- HEAT EXCHANGERS -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 451852 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 26000 | apmTranslate }}@if (fieldMappings().coolingCapacity.symbol) { [{{ fieldMappings().coolingCapacity.symbol }}]}*
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="coolingCapacity" [mapping]="fieldMappings().coolingCapacity.mapping" [uomSystem]="mainStore.uomSystem()"></apm-convertible-input>
      </div>
    </div>
  </div>

  <!-- EVAPORATOR -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 457032 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456941 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="evapInletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="evapInletType"
          (selectChange)="onEvapInletTypeChange()"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456943 | apmTranslate }}@if (fieldMappings().evapInletValue.symbol) { [{{ fieldMappings().evapInletValue.symbol }}]}*
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="evapInletValue" [mapping]="fieldMappings().evapInletValue.mapping" [uomSystem]="mainStore.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456942 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control disabled-select">
        <apm-select
          [items]="evapInletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="evapOutletType"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456944 | apmTranslate }}@if (fieldMappings().evapOutletTemp.symbol) { [{{ fieldMappings().evapOutletTemp.symbol }}]}*
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="evapOutletTemp" [mapping]="fieldMappings().evapOutletTemp.mapping" [uomSystem]="mainStore.uomSystem()"></apm-convertible-input>
      </div>
    </div>
  </div>

  <!-- CONDENSER -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 457033 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456941 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control disabled-select">
        <apm-select
          [items]="condOutletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="condInletType"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456943 | apmTranslate }}@if (fieldMappings().condInletTemp.symbol) { [{{ fieldMappings().condInletTemp.symbol }}]}*
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="condInletTemp" [mapping]="fieldMappings().condInletTemp.mapping" [uomSystem]="mainStore.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456942 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="condOutletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="condOutletType"
          (selectChange)="onCondOutletTypeChange()"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456944 | apmTranslate }}@if (fieldMappings().condOutletVal.symbol) { [{{ fieldMappings().condOutletVal.symbol }}]}*
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="condOutletVal" [mapping]="fieldMappings().condOutletVal.mapping" [uomSystem]="mainStore.uomSystem()"></apm-convertible-input>
      </div>
    </div>
  </div>

  <!-- PARTIAL LOADS -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 452671 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div formArrayName="loadPcts">
      @for (control of loadPcts.controls; track $index) {
        <div class="chiller-free-st-field-row">
          <div class="chiller-free-st-field-label">{{ $index + 1 }} [%]</div>
          <div class="chiller-free-st-field-control">
            <input type="number" apmInput [formControlName]="$index" />
            <apm-field-errors [control]="control"></apm-field-errors>
          </div>
        </div>
      }
      <apm-field-errors [control]="loadPcts" [showOnlyOnTouch]="false" [customMessages]="loadPctsErrorMessages"></apm-field-errors>
    </div>
  </div>
</form>
